import { render, staticRenderFns } from "./IssuetrackingCreatesplit.vue?vue&type=template&id=98c5e14e&"
import script from "./IssuetrackingCreatesplit.vue?vue&type=script&lang=js&"
export * from "./IssuetrackingCreatesplit.vue?vue&type=script&lang=js&"
import style0 from "./IssuetrackingCreatesplit.vue?vue&type=style&index=0&id=98c5e14e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports